import ApprovalCard from "../Spark/MainContent/Messages/ApprovalCard";

export const getMatchingNebulaApprovals = (pendingApprovals, messageId, answerId) => {
  const approvals = Object.values(pendingApprovals || {});
  const answerMatches = answerId
    ? approvals.filter((approval) => approval.answer_id === answerId)
    : [];

  return answerMatches.length > 0
    ? answerMatches
    : approvals.filter((approval) => approval.message_id === messageId);
};

const NebulaApprovalPanel = ({
  pendingApprovals,
  messageId,
  answerId,
  onApprove,
  onCancel,
  onExpire,
}) => {
  const approvals = getMatchingNebulaApprovals(pendingApprovals, messageId, answerId);
  if (approvals.length === 0) return null;

  return (
    <section
      aria-label="Pending approvals"
      className="max-w-4xl w-full mx-auto px-8 py-3 flex flex-col gap-3"
    >
      {approvals.map((approval) => (
        <ApprovalCard
          key={approval.approval_id}
          cardData={approval}
          onApprove={onApprove}
          onCancel={onCancel}
          onExpire={onExpire}
        />
      ))}
    </section>
  );
};

export default NebulaApprovalPanel;
